module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "introh"
  }, [_c('i', [_vm._v("Let Me Tell You Why I Love Precuts")])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("First, they’re "), _c('i', [_vm._v("pre")]), _vm._v("-cut! How many hours do quilters spend cutting? By the time you’re done, you don’t even want to sew! One day a woman with severe arthritis came into my shop to buy precuts. I asked her how, with such gnarled hands, she was able to quilt. She replied, “Oh, Honey, I’m not going to stop reading just because I can’t hold a book!” She taught me that when you are passionate about something, you don’t stop doing it—you just find a way to make it easier.")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("When you walk into a fabric store, it’s easy to get overwhelmed. The thought of having to gather 40 different bolts of fabric with just the right color and print is too much to handle. I love that precuts are from one coordinating collection. It’s like having a designer standing beside you, telling you what to choose, turning hours of indecision into a process that takes only a few minutes. Then I’m always amazed when my finished quilt looks so much better than I ever could’ve imagined. So I have learned to trust the designers.")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("With this book, you can become inspired by precuts. It includes more than 25 block patterns and tips and tricks for using precuts. There are also easy-to-follow yardage charts for borders, backing, and binding—everything you need to make a quilt.")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Life is busy. Someone is always getting married, graduating, or having a baby … and let’s face it, you want to create something memorable for each of them without having to work too hard. Precuts are the answer. So grab your precuts and let them do the work for you!")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('i', [_vm._v("Happy quilting!")])]), _vm._v(" "), _c('p', {
    staticClass: "figl"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/sign.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figl"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/dedi.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "intros"
  }, [_vm._v("Jenny Doan")]), _vm._v(" "), _c('p', {
    staticClass: "intros"
  }, [_c('i', [_vm._v("Missouri Star Quilt Company")])]), _vm._v(" "), _c('p', {
    staticClass: "intros"
  }, [_c('a', {
    attrs: {
      "href": "http://www.missouriquiltco.com",
      "target": "_blank"
    }
  }, [_vm._v("missouriquiltco.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e2622c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/intro.vue
// module id = 60
// module chunks = 0